import React, { useEffect, useState } from 'react';
import {
  VegaComboBox,
  VegaDropdownItem,
  VegaFlex,
  VegaFont
} from '@heartlandone/vega-react';
import { VegaNotify } from '@heartlandone/vega';
import { _fetch } from 'Chore/Request';
import { PATH } from 'Chore/Apis';
import Avatar from '../Avatar';

const { GET_EMAIL_RECEIVERS } = PATH;

const EmailUserSelector = ({
                             isOpen,
                             value,
                             onChange,
                             onOptionsChange,
                             label,
                             placeholder
                           }) => {
  const [options, setOptions] = useState([]);
  const [filteredOptions, setFilteredOptions] = useState([]);
  const [searchValue, setSearchValue] = useState('');

  useEffect(() => {
    if (isOpen) {
      setSearchValue('');
      _fetch({ api: GET_EMAIL_RECEIVERS(), method: 'GET' })
        .then(res => {
          if (res.code !== 2200) {
            VegaNotify.open({
              type: 'error',
              message: res.message || 'The recipients could not be fetched.'
            });
            return;
          }
          const { emailGroups = [], emailUsers = [] } = res.payload || {};
          const formattedGroups = emailGroups.map(group => ({
            key: group.groupId,
            label: `${group.name} (${group.totalMembers})`,
            name: group.name,
            type: 'group',
            count: group.totalMembers
          }));
          const formattedUsers = emailUsers.map(user => ({
            key: user.id,
            label: user.name,
            name: user.name,
            type: 'user',
            email: user.email,
            role: user.role,
            avatar: user.avatar
          }));
          const allOptions = [...formattedGroups, ...formattedUsers];
          setOptions(allOptions);
          setFilteredOptions(allOptions);
          onOptionsChange?.(allOptions);
        })
        .catch(() => {
          VegaNotify.open({
            type: 'error',
            message: 'The recipients could not be fetched.'
          });
        });
    } else {
      setOptions([]);
      setFilteredOptions([]);
      setSearchValue('');
    }
  }, [isOpen, onOptionsChange]);

  const handleSearch = e => {
    const searchString = e.detail.trim().toLowerCase();
    setSearchValue(e.detail);
    if (!searchString) {
      setFilteredOptions(options);
    } else {
      const filtered = options.filter(option =>
        option.label.toLowerCase().startsWith(searchString)
      );
      setFilteredOptions(filtered);
    }
  };

  return (
    <VegaComboBox
      label={label}
      value={value}
      data-vega-form="receiverList"
      multiple
      required
      placeholder={placeholder}
      useDefaultFilter={true}
      searchValue={searchValue}
      onVegaSearch={handleSearch}
      onVegaChange={e => {
        onChange(e.detail);
        setSearchValue('');
        setFilteredOptions(options);
      }}
      style={{ marginBottom: '-8px' }}
    >
      <div slot="items" gap="size-14" style={{overflow: 'hidden'}}>
        {filteredOptions.map(item => (
          <VegaDropdownItem key={item.key} item-key={item.key} label={item.label}>
            <VegaFlex alignItems="center">
              <Avatar name={item.name} width="size-36" avatarUrl={item.avatar} />
              <VegaFlex direction="col" style={{ marginLeft: '14px' }}>
                <VegaFont style={{ fontWeight: 700 }}>{item.name}</VegaFont>
                <VegaFont
                  level="body-3"
                  color="secondary"
                  style={{ fontWeight: 400 }}
                >
                  {item.type === 'group'
                    ? `${item.count} members`
                    : item.role
                      ? `${item.role} / ${item.email}`
                      : item.email}
                </VegaFont>
              </VegaFlex>
            </VegaFlex>
          </VegaDropdownItem>
        ))}
      </div>
    </VegaComboBox>
  );
};

export default EmailUserSelector;